import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  CalendarOutlined,
  GroupOutlined,
  HeatMapOutlined,
  DashboardOutlined,
  DollarOutlined,
  DingtalkOutlined,
  TableOutlined,
  ScheduleOutlined,
  TagOutlined,
} from "@ant-design/icons";

// Lodash
import _drop from "lodash/drop";

// Components
import Menu from "../../../../atoms/menu";
import { Title } from "../../../../atoms/typography";

// Styles
import styles from "./sideBar.module.scss";

// Assets
import logo from "../../../../../assets/images/logo.png";

const { SubMenu } = Menu;

function Sidebar() {
  const [activeMenuItems, setActiveMenuItems] = useState(["dashboard"]);
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    const currentActiveMenuItem = pathname?.split("/");
    setActiveMenuItems(_drop(currentActiveMenuItem, 1));
  }, [location]);

  const { REACT_APP_URL, NODE_ENV } = process.env
  const devAll = REACT_APP_URL === "dev" || NODE_ENV === "development"
  const dev = NODE_ENV === "development"
  return (
    <>
      <div className={styles.logo}>
        <img className="h-8 w-auto" src={logo} alt="Dudi Business" />
        <Title className={styles.appTitle}>Business</Title>
      </div>
      <Menu
        mode="inline"
        defaultSelectedKeys={["dashboard"]}
        selectedKeys={activeMenuItems}
        className={styles.menuContainer}
        theme="dark"
        defaultOpenKeys={["dashboard"]}
      >
        <Menu.Item key="sales" icon={<DollarOutlined />}>
          <Link to="/sales">Sales</Link>
        </Menu.Item>
        <Menu.Item key="packages" icon={<GroupOutlined />}>
          <Link to="/packages">Packages</Link>
        </Menu.Item>
        <Menu.Item key="pitches" icon={<HeatMapOutlined />}>
          <Link to="/pitches">Pitches</Link>
        </Menu.Item>

        {/* <Menu.Item key="schedules" icon={<ScheduleOutlined />}>
          <Link to="/schedules">Schedules</Link>
        </Menu.Item> */}
        {devAll || dev ? <Menu.Item key="calendars" icon={<CalendarOutlined />}>
          <Link to="/calendars">Calendars</Link>
        </Menu.Item> : null}

        <Menu.Item key="activities" icon={<DingtalkOutlined />}>
          <Link to="/activities">Activities</Link>
        </Menu.Item>
        <Menu.Item key="posts" icon={<TableOutlined />}>
          <Link to="/posts">Posts</Link>
        </Menu.Item>
        <Menu.Item key="promotion" icon={<TagOutlined />}>
          <Link to="/promotion">Promotion</Link>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default Sidebar;
